import React from "react";

const ContactForm = ({
  customerInfo,
  handleCustomerInfoChange,
  isValidEmail,
  isValidUSPhone,
}) => (
  <form className="space-y-4 mb-6">
    <label className="block font-semibold mb-1">
      First Name <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      name="firstName"
      placeholder="First Name"
      required
      maxLength={40}
      value={customerInfo.firstName}
      onChange={handleCustomerInfoChange}
      className="w-full px-4 py-3 rounded-xl border border-gray-300"
    />
    <label className="block font-semibold mb-1">
      Last Name <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      name="lastName"
      placeholder="Last Name"
      required
      autoComplete="family-name"
      maxLength={40}
      value={customerInfo.lastName}
      onChange={handleCustomerInfoChange}
      className="w-full px-4 py-3 rounded-xl border border-gray-300"
    />
    <label className="block font-semibold mb-1">
      Email Address <span className="text-red-500">*</span>
    </label>
    <input
      type="email"
      name="email"
      placeholder="Email Address"
      required
      maxLength={60}
      value={customerInfo.email || ""}
      onChange={handleCustomerInfoChange}
      className={`w-full px-4 py-3 rounded-xl border ${
        customerInfo.email && !isValidEmail(customerInfo.email)
          ? "border-red-500"
          : "border-gray-300"
      }`}
    />
    {customerInfo.email && !isValidEmail(customerInfo.email) && (
      <p className="text-red-500 text-sm mt-1">
        Please enter a valid email address.
      </p>
    )}
    <label className="block font-semibold mb-1">
      Phone Number <span className="text-red-500">*</span>
    </label>
    <input
      type="tel"
      name="phone"
      placeholder="Phone Number"
      required
      maxLength={20}
      value={customerInfo.phone}
      onChange={handleCustomerInfoChange}
      className={`w-full px-4 py-3 rounded-xl border ${
        customerInfo.phone && !isValidUSPhone(customerInfo.phone)
          ? "border-red-500"
          : "border-gray-300"
      }`}
    />
    {customerInfo.phone && !isValidUSPhone(customerInfo.phone) && (
      <p className="text-red-500 text-sm mt-1">
        Please enter a valid US phone number.
      </p>
    )}
  </form>
);

export default ContactForm;